module.exports = {

  prefix: '',

  important: ':root',

  purge: {

    enabled: true,

    content: ["./src/**/*.{html,ts}"],

  },

  separator: ':',

  theme: {

    screens: {

      sm: '600px',

      md: '960px',

      lg: '1280px'

    },

    colors: {

      transparent: 'transparent',



      black: 'var(--text-color)',

      white: 'var(--text-color-light)',

      'contrast-black': 'black',

      'contrast-white': 'white',



      gray: {

        50: '#fafafa',

        100: '#f6f6f6',

        200: '#e8e8e8',

        300: '#b6b6b6',

        400: '#636363',

        500: '#1a1a1a',

        600: '#171717',

        700: '#151515',

        800: '#141414',

        900: '#141414',

      },

      red: {

        50: '#fff7f8',

        100: '#ffeff1',

        200: '#ffebee',

        300: '#ffc1ca',

        400: '#ff8e96',

        500: '#ff4e5b',

        600: '#e6314c',

        700: '#cc2b43',

        800: '#bf293f',

        900: '#992032',

      },

      orange: {

        50: '#fffaf5',

        100: '#fff5eb',

        200: '#fff2e6',

        300: '#ffecd9',

        400: '#ffd7b0',

        500: '#f28500',

        600: '#e67100',

        700: '#cc6500',

        800: '#bf5f00',

        900: '#994c00',

      },

      'deep-orange': {

        50: '#fbe9e7',

        100: '#ffccbc',

        200: '#ffab91',

        300: '#ff8a65',

        400: '#ff7043',

        500: '#ff5722',

        600: '#f4511e',

        700: '#e64a19',

        800: '#d84315',

        900: '#bf360c',

      },

      amber: {

        50: '#fff8e1',

        100: '#ffecb3',

        200: '#ffe082',

        300: '#ffd54f',

        400: '#ffca28',

        500: '#ffc107',

        600: '#ffb300',

        700: '#ffa000',

        800: '#ff8f00',

        900: '#ff6f00',

      },

      'light-green': {

        50: '#f1f8e9',

        100: '#dcedc8',

        200: '#c5e1a5',

        300: '#aed581',

        400: '#9ccc65',

        500: '#8bc34a',

        600: '#7cb342',

        700: '#689f38',

        800: '#558b2f',

        900: '#33691e',

      },

      green: {

        50: '#f5fcfa',

        100: '#ebf8f4',

        200: '#e6f7f2',

        300: '#d9f2eb',

        400: '#b0e5d6',

        500: '#00ab7a',

        600: '#009a6e',

        700: '#008962',

        800: '#00805c',

        900: '#006749',

      },

      teal: {

        50: '#e0f2f1',

        100: '#b2dfdb',

        200: '#80cbc4',

        300: '#4db6ac',

        400: '#26a69a',

        500: '#009688',

        600: '#00897b',

        700: '#00796b',

        800: '#00695c',

        900: '#004d40',

      },

      cyan: {

        50: '#e0f7fa',

        100: '#b2ebf2',

        200: '#80deea',

        300: '#4dd0e1',

        400: '#26c6da',

        500: '#00bcd4',

        600: '#00acc1',

        700: '#0097a7',

        800: '#00838f',

        900: '#006064',

      },

      purple: {

        50: '#f3e5f5',

        100: '#e1bee7',

        200: '#F2CDFF',

        300: '#ba68c8',

        400: '#ab47bc',

        500: '#9c27b0',

        600: '#8e24aa',

        700: '#7b1fa2',

        800: '#A73ECC',

        900: '#4a148c',

      },

      'deep-purple': {

        50: '#ede7f6',

        100: '#d1c4e9',

        200: '#b39ddb',

        300: '#9575cd',

        400: '#7e57c2',

        500: '#673ab7',

        600: '#5e35b1',

        700: '#512da8',

        800: '#4527a0',

        900: '#311b92',

      },

      primary: {

        50: '#f5f5f8',

        100: '#ebebf1',

        200: '#e6e7ee',

        300: '#dadae6',

        400: '#b2b3cb',

        500: '#D95938',

        600: '#07094d',

        700: '#060845',

        800: '#060841',

        900: '#050634',

      },

      'blue': {

        400: '#E9E9FE',

        700: '#191FC2'

      }

    },

    spacing: {

      px: '1px',

      gutter: 'var(--padding-gutter)',

      '0': '0',

      '1': '0.25rem',

      '2': '0.5rem',

      '3': '0.75rem',

      '4': '1rem',

      '5': '1.25rem',

      '6': '1.5rem',

      '8': '2rem',

      '9': '2.25rem',

      '10': '2.5rem',

      '12': '3rem',

      '14': '3.5rem',

      '16': '4rem',

      '20': '5rem',

      '24': '6rem',

      '32': '8rem',

      '40': '10rem',

      '48': '12rem',

      '56': '14rem',

      '64': '16rem',

    },

    backgroundColor: theme => ({

      base: 'var(--background-base)',

      card: 'var(--background-card)',

      'app-bar': 'var(--background-app-bar)',

      hover: 'var(--background-hover)',

      ...theme('colors'),

    }),

    backgroundPosition: {

      bottom: 'bottom',

      center: 'center',

      left: 'left',

      'left-bottom': 'left bottom',

      'left-top': 'left top',

      right: 'right',

      'right-bottom': 'right bottom',

      'right-top': 'right top',

      top: 'top',

    },

    backgroundSize: {

      auto: 'auto',

      cover: 'cover',

      contain: 'contain',

    },

    borderColor: theme => ({

      ...theme('colors'),

      default: 'var(--foreground-divider)',

    }),

    borderRadius: {

      none: '0',

      sm: '0.125rem',

      default: '0.25rem',

      lg: '0.5rem',

      full: '9999px',

    },

    borderWidth: {

      default: '1px',

      '0': '0',

      '2': '2px',

      '4': '4px',

      '8': '8px',

    },

    boxShadow: {

      default: 'var(--elevation-z6)',

      md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',

      lg: '0px 7px 8px -4px rgba(82, 63, 104, 0.06),0px 12px 17px 2px rgba(82, 63, 104, 0.042),0px 5px 22px 4px rgba(82, 63, 104, 0.036)',

      xl: '0px 8px 10px -5px rgba(82, 63, 104, 0.06),0px 16px 24px 2px rgba(82, 63, 104, 0.042),0px 6px 30px 5px rgba(82, 63, 104, 0.036)',

      '2xl': '0 25px 50px -12px rgba(0, 0, 0, 0.25)',

      inner: 'inset 0 2px 4px 0 rgba(0, 0, 0, 0.06)',

      outline: '0 0 0 3px rgba(66, 153, 225, 0.5)',

      none: 'none',

      b: '0 10px 30px 0 rgba(82,63,104,.06)',

      1: 'var(--elevation-z1)',

      2: 'var(--elevation-z2)',

      3: 'var(--elevation-z3)',

      4: 'var(--elevation-z4)',

      5: 'var(--elevation-z5)',

      6: 'var(--elevation-z6)',

      7: 'var(--elevation-z7)',

      8: 'var(--elevation-z8)',

      9: 'var(--elevation-z9)',

      10: 'var(--elevation-z10)',

      11: 'var(--elevation-z11)',

      12: 'var(--elevation-z12)',

      13: 'var(--elevation-z13)',

      14: 'var(--elevation-z14)',

      15: 'var(--elevation-z15)',

      16: 'var(--elevation-z16)',

      17: 'var(--elevation-z17)',

      18: 'var(--elevation-z18)',

      19: 'var(--elevation-z19)',

      20: 'var(--elevation-z20)',

    },

    container: {

      center: true,

      padding: 'var(--padding-gutter)'

    },

    cursor: {

      auto: 'auto',

      default: 'default',

      pointer: 'pointer',

      wait: 'wait',

      text: 'text',

      move: 'move',

      'not-allowed': 'not-allowed',

    },

    fill: {

      current: 'currentColor',

    },

    flex: {

      '1': '1 1 0%',

      auto: '1 1 auto',

      initial: '0 1 auto',

      none: 'none',

    },

    flexGrow: {

      '0': '0',

      default: '1',

    },

    flexShrink: {

      '0': '0',

      default: '1',

    },

    fontFamily: {

      sans: [

        'BDO Grotesk',

        'Roboto',

        '-apple-system',

        'BlinkMacSystemFont',

        '"Segoe UI"',

        'Roboto',

        '"Helvetica Neue"',

        'Arial',

        '"Noto Sans"',

        'sans-serif',

        '"Apple ColorDef Emoji"',

        '"Segoe UI Emoji"',

        '"Segoe UI Symbol"',

        '"Noto ColorDef Emoji"',

      ],

      serif: [

        'Georgia',

        'Cambria',

        '"Times New Roman"',

        'Times',

        'serif',

      ],

      mono: [

        'Menlo',

        'Monaco',

        'Consolas',

        '"Liberation Mono"',

        '"Courier New"',

        'monospace',

      ],

    },

    fontSize: {

      xs: '0.75rem',

      sm: '0.875rem',

      base: '1rem',

      lg: '1.125rem',

      xl: '1.25rem',

      '2xl': '1.5rem',

      '3xl': '1.875rem',

      '4xl': '2.25rem',

      '5xl': '3rem',

      '6xl': '4rem',

    },

    fontWeight: {

      hairline: '100',

      thin: '200',

      light: '300',

      normal: '400',

      medium: '500',

      semibold: '600',

      bold: '700',

      extrabold: '800',

      black: '900',

    },

    height: theme => ({

      auto: 'auto',

      ...theme('spacing'),

      full: '100%',

      screen: '100vh',

    }),

    inset: {

      '0': '0',

      '1': '0.25rem',

      '2': '0.5rem',

      '3': '0.75rem',

      '4': '1rem',

      '5': '1.25rem',

      '6': '1.5rem',

      '8': '2rem',

      '10': '2.5rem',

      '12': '3rem',

      '-1': '-0.25rem',

      '-2': '-0.5rem',

      '-3': '-0.75rem',

      '-4': '-1rem',

      '-5': '-1.25rem',

      '-6': '-1.5rem',

      '-8': '-2rem',

      '-10': '-2.5rem',

      '-12': '-3rem',

      auto: 'auto',

    },

    letterSpacing: {

      tighter: '-0.05em',

      tight: '-0.025em',

      normal: '0',

      wide: '0.025em',

      wider: '0.05em',

      widest: '0.1em',

    },

    lineHeight: {

      none: '1',

      tight: '1.25',

      snug: '1.375',

      normal: '1.5',

      relaxed: '1.625',

      loose: '2',

    },

    listStyleType: {

      none: 'none',

      disc: 'disc',

      decimal: 'decimal',

    },

    margin: (theme, { negative }) => ({

      auto: 'auto',

      ...theme('spacing'),

      ...negative(theme('spacing')),

      ...negative({

        gutter: 'var(--padding-gutter)'

      })

    }),

    maxHeight: {

      full: '100%',

      screen: '100vh',

    },

    maxWidth: {

      xxxs: '16rem',

      xxs: '18rem',

      xs: '20rem',

      sm: '24rem',

      md: '28rem',

      lg: '32rem',

      xl: '36rem',

      '2xl': '42rem',

      '3xl': '48rem',

      '4xl': '56rem',

      '5xl': '64rem',

      '6xl': '72rem',

      full: '100%',

    },

    minHeight: {

      '0': '0',

      full: '100%',

      screen: '100vh',

    },

    minWidth: theme => ({

      '0': '0',

      full: '100%',

      ...theme('spacing')

    }),

    objectPosition: {

      bottom: 'bottom',

      center: 'center',

      left: 'left',

      'left-bottom': 'left bottom',

      'left-top': 'left top',

      right: 'right',

      'right-bottom': 'right bottom',

      'right-top': 'right top',

      top: 'top',

    },

    opacity: {

      '0': '0',

      '25': '0.25',

      '50': '0.5',

      '75': '0.75',

      '100': '1',

    },

    order: {

      first: '-9999',

      last: '9999',

      none: '0',

      '1': '1',

      '2': '2',

      '3': '3',

      '4': '4',

      '5': '5',

      '6': '6',

      '7': '7',

      '8': '8',

      '9': '9',

      '10': '10',

      '11': '11',

      '12': '12',

    },

    padding: theme => theme('spacing'),

    placeholderColor: theme => theme('colors'),

    stroke: {

      current: 'currentColor',

    },

    textColor: theme => ({

      'secondary': 'var(--text-secondary)',

      'hint': 'var(--text-hint)',

      ...theme('colors'),

      'primary-contrast': {

        50: '#000',

        100: '#000',

        200: '#000',

        300: '#000',

        400: '#000',

        500: '#FFF',

        600: '#FFF',

        700: '#FFF',

        800: '#FFF',

        900: '#FFF',

      },

      'red-contrast': {

        50: '#000',

        100: '#000',

        200: '#000',

        300: '#000',

        400: '#000',

        500: '#FFF',

        600: '#FFF',

        700: '#FFF',

        800: '#FFF',

        900: '#FFF',

      },

      'green-contrast': {

        50: '#000',

        100: '#000',

        200: '#000',

        300: '#000',

        400: '#000',

        500: '#FFF',

        600: '#FFF',

        700: '#FFF',

        800: '#FFF',

        900: '#FFF',

      },

      'amber-contrast': {

        50: '#000',

        100: '#000',

        200: '#000',

        300: '#000',

        400: '#000',

        500: '#000',

        600: '#000',

        700: '#000',

        800: '#000',

        900: '#000',

      },

      'orange-contrast': {

        50: '#000',

        100: '#000',

        200: '#000',

        300: '#000',

        400: '#000',

        500: '#000',

        600: '#000',

        700: '#000',

        800: '#FFF',

        900: '#FFF',

      },

      'deep-orange-contrast': {

        50: '#000',

        100: '#000',

        200: '#000',

        300: '#000',

        400: '#000',

        500: '#FFF',

        600: '#FFF',

        700: '#FFF',

        800: '#FFF',

        900: '#FFF',

      },

      'purple-contrast': {

        50: '#000',

        100: '#000',

        200: '#000',

        300: '#FFF',

        400: '#FFF',

        500: '#FFF',

        600: '#FFF',

        700: '#FFF',

        800: '#FFF',

        900: '#FFF',

      },

      'deep-purple-contrast': {

        50: '#000',

        100: '#000',

        200: '#000',

        300: '#FFF',

        400: '#FFF',

        500: '#FFF',

        600: '#FFF',

        700: '#FFF',

        800: '#FFF',

        900: '#FFF',

      },

      'cyan-contrast': {

        50: '#000',

        100: '#000',

        200: '#000',

        300: '#000',

        400: '#000',

        500: '#FFF',

        600: '#FFF',

        700: '#FFF',

        800: '#FFF',

        900: '#FFF',

      },

      'teal-contrast': {

        50: '#000',

        100: '#000',

        200: '#000',

        300: '#000',

        400: '#000',

        500: '#FFF',

        600: '#FFF',

        700: '#FFF',

        800: '#FFF',

        900: '#FFF',

      },

      'gray-contrast': {

        50: '#000',

        100: '#000',

        200: '#000',

        300: '#000',

        400: '#000',

        500: '#FFF',

        600: '#FFF',

        700: '#FFF',

        800: '#FFF',

        900: '#FFF',

      },

      'light-green-contrast': {

        50: '#000',

        100: '#000',

        200: '#000',

        300: '#000',

        400: '#000',

        500: '#000',

        600: '#000',

        700: '#FFF',

        800: '#FFF',

        900: '#FFF',

      },

    }),

    width: theme => ({

      auto: 'auto',

      ...theme('spacing'),

      '1/2': '50%',

      '1/3': '33.333333%',

      '2/3': '66.666667%',

      '1/4': '25%',

      '2/4': '50%',

      '3/4': '75%',

      '1/5': '20%',

      '2/5': '40%',

      '3/5': '60%',

      '4/5': '80%',

      '1/6': '16.666667%',

      '2/6': '33.333333%',

      '3/6': '50%',

      '4/6': '66.666667%',

      '5/6': '83.333333%',

      '1/12': '8.333333%',

      '2/12': '16.666667%',

      '3/12': '25%',

      '4/12': '33.333333%',

      '5/12': '41.666667%',

      '6/12': '50%',

      '7/12': '58.333333%',

      '8/12': '66.666667%',

      '9/12': '75%',

      '10/12': '83.333333%',

      '11/12': '91.666667%',

      full: '100%',

      screen: '100vw',

    }),

    zIndex: {

      auto: 'auto',

      '0': '0',

      '10': '10',

      '20': '20',

      '30': '30',

      '40': '40',

      '50': '50',

    },

  },

  variants: {

    accessibility: ['responsive', 'focus'],

    alignContent: ['responsive'],

    alignItems: ['responsive'],

    alignSelf: ['responsive'],

    appearance: ['responsive'],

    backgroundAttachment: ['responsive'],

    backgroundColor: ['responsive', 'hover', 'focus'],

    backgroundPosition: ['responsive'],

    backgroundRepeat: ['responsive'],

    backgroundSize: ['responsive'],

    borderCollapse: ['responsive'],

    borderColor: ['responsive', 'hover', 'focus'],

    borderRadius: ['responsive'],

    borderStyle: ['responsive'],

    borderWidth: ['responsive', 'ltr', 'rtl'],

    boxShadow: ['responsive', 'hover', 'focus'],

    cursor: ['responsive'],

    display: ['responsive'],

    fill: ['responsive'],

    flex: ['responsive'],

    flexDirection: ['responsive'],

    flexGrow: ['responsive'],

    flexShrink: ['responsive'],

    flexWrap: ['responsive'],

    float: ['responsive'],

    fontFamily: ['responsive'],

    fontSize: ['responsive'],

    fontSmoothing: ['responsive'],

    fontStyle: ['responsive'],

    fontWeight: ['responsive', 'hover', 'focus'],

    height: ['responsive'],

    inset: ['responsive', 'ltr', 'rtl'],

    justifyContent: ['responsive'],

    letterSpacing: ['responsive'],

    lineHeight: ['responsive'],

    listStylePosition: ['responsive'],

    listStyleType: ['responsive'],

    margin: ['responsive', 'ltr', 'rtl'],

    maxHeight: ['responsive'],

    maxWidth: ['responsive'],

    minHeight: ['responsive'],

    minWidth: ['responsive'],

    objectFit: ['responsive'],

    objectPosition: ['responsive'],

    opacity: ['responsive', 'hover', 'focus'],

    order: ['responsive'],

    outline: ['responsive', 'focus'],

    overflow: ['responsive'],

    padding: ['responsive', 'ltr', 'rtl'],

    placeholderColor: ['responsive', 'focus'],

    pointerEvents: ['responsive'],

    position: ['responsive'],

    resize: ['responsive'],

    stroke: ['responsive'],

    tableLayout: ['responsive'],

    textAlign: ['responsive'],

    textColor: ['responsive', 'hover', 'focus'],

    textDecoration: ['responsive', 'hover', 'focus'],

    textTransform: ['responsive'],

    userSelect: ['responsive'],

    verticalAlign: ['responsive'],

    visibility: ['responsive'],

    whitespace: ['responsive'],

    width: ['responsive'],

    wordBreak: ['responsive'],

    zIndex: ['responsive'],

  },

  corePlugins: {},

  plugins: [

    function ({ addVariant, e }) {

      addVariant('ltr', ({ separator, modifySelectors }) => {

        modifySelectors(({ className }) => {

          return `[dir=ltr] .ltr${e(separator)}${className}`;

        })

      });



      addVariant('rtl', ({ separator, modifySelectors }) => {

        modifySelectors(({ className }) => {

          return `[dir=rtl] .rtl${e(separator)}${className}`;

        })

      });

    }

  ],

};
